import { compactStrings } from "./strings";

export interface PostalAddressParts {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}

export function formatPostalAddress(parts: PostalAddressParts): string | null {
  const street = compactStrings([parts.addressLine1, parts.addressLine2]).join(
    ", ",
  );
  const cityStateZip = compactStrings([
    parts.city,
    parts.state,
    parts.zip,
  ]).join(" ");
  const address = compactStrings([street, cityStateZip]).join(", ");

  return address || null;
}
